import * as R from "ramda";

export const isLoading = (action, state) =>
  action.getStatus(state) === "pending";

export const isInitialLoading = R.curry((action, state) =>
  ["init", "pending"].includes(action.getStatus(state))
);
